import { useMutation, useQuery } from 'react-query'
import request from '../../request'
import { isEmpty } from 'lodash'

export const useGetAgencyVendorCampaignsByVendorId = ({
  agency_id,
  vendor_id,
  params,
}: any) => {
  const shouldEnable = agency_id && vendor_id && !isEmpty(params)
  return useQuery(
    ['agencies', agency_id, 'dsp', 'vendors', vendor_id, 'campaigns', params],
    ({ signal }) =>
      request<{ data: Array<any> }>({
        url: `/agencies/${agency_id}/dsp/accounts/vendors/${vendor_id}/campaigns`,
        method: 'GET',
        params: {
          ...params,
        },
        signal,
      }).then((res) => res.data),
    {
      enabled: shouldEnable,
      refetchOnWindowFocus: false,
    },
  )
}
